import * as Form from '../../components/form'

export const FETCH_CAMPAIGNS = 'FETCH_CAMPAIGNS'
export const UPDATE_CAMPAIGN = 'UPDATE_CAMPAIGN'
export const UPDATE_CAMPAIGN_TIER = 'UPDATE_CAMPAIGN_TIER'
export const SELECT_CAMPAIGN = 'SELECT_CAMPAIGN'
export const CAMPAIGN_FORM = 'CAMPAIGN_FORM'
export const TIER_FORM = 'TIER_FORM'
export const CampaignFormConstantsMap = Form.createConstantsMap(CAMPAIGN_FORM)
export const TierFormConstantsMap = Form.createConstantsMap(TIER_FORM)
export const TIER_CLICK = 'TIER_CLICK'

export const SERVER_HOME = '/campaigns/referral'



// WEBPACK FOOTER //
// ./src/pages/referral-campaigns/constants.ts